import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { httpsCallable, getFunctions } from "firebase/functions";
import Swal from "sweetalert2";

export default function AddUser({setAddUserCheck, printAllUsers}) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const functions = getFunctions();

    const handleAddUser = async (e) => {
        e.preventDefault();
    
        if (isSubmitting) return;
    
        let errorMessage = null;
        let errorTitle = "Error";
    
        try {
            setIsSubmitting(true);
            document.body.style.cursor = "wait";
    
            const fullEmail = email + "@maranaaz.gov";
            const createUser = httpsCallable(functions, "createUser");
    
            await createUser({ email: fullEmail, password, role: "user" });
    
            Swal.fire({
                icon: "success",
                title: "Account Created!",
                text: "The new user account has been created successfully.",
                confirmButtonColor: "#3085d6",
            });
    
            setAddUserCheck(false);
            printAllUsers();
    
            return; 
    
        } catch (error) {
    
            if (error.message?.includes("PASSWORD_DOES_NOT_MEET_REQUIREMENTS")) {
                errorMessage =
                    "Password must be at least 6 characters long, include uppercase, lowercase, number, and special character.";
            } 
            else if (error.code === "already-exists") {
                errorMessage = "A user with this email already exists.";
            } 
            else {
                errorMessage = error.message;
            }
    
            Swal.fire({
                icon: "error",
                title: errorTitle,
                text: errorMessage,
            });
    
        } finally {
            setIsSubmitting(false);
            document.body.style.cursor = "default";
        }
    };

    const handleChange = (e) => {
        let value = e.target.value;
      
       value = value.replace(/@/g, "");     
        value = value.replace(/\.com/g, "");  
        value = value.replace(/\.gov/g, "");
        value = value.replace(/\.org/g, "");    
        value = value.replace(/\s/g, ""); 
      
        setEmail(value);
      };
    
    const handleKeyDown = (e) => {
        if (e.key === "@" || e.key === " ") {
            e.preventDefault();
        }
    };
    
    return (

        <div className="add-user-background">
            <h3>Add A New User</h3>

            <form className="add-user-form" onSubmit={handleAddUser} name="add-user-form">
                <TextField value={email} onChange={handleChange} onKeyDown={handleKeyDown} label="Email" placeholder="Email" required size="small" sx={{ "& .MuiInputLabel-root.Mui-focused": {
                    color: "black" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { border: "1px solid black", color: "black" }, },}} InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            @maranaaz.gov
                          </InputAdornment>
                        ),
                      }}/>

                <TextField onChange={(e) => setPassword(e.target.value)} label="Password" type="text" placeholder="Password" required size="small" sx={{
                    "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { border: "1px solid black", color: "black" },},}}/>
                <p style={{color: "red", fontSize: "12px", margin: "0 auto", marginTop: "-5px", marginBottom: "0px"}}><strong>Note: </strong>
                    Only <strong>@maranaaz.gov</strong> email addresses are permitted.</p>
                <button type="submit" className="submit-add-user" disabled={isSubmitting}>Add User</button>
            </form>
        </div>
    );
}
